import { Modal, Button, Col, Row, Space, Typography, message } from "antd";
import { useState } from "react";
import { SearchQuery } from "../code/search-query/search-query";
import Loader from "../controls/Loader";
import BadgesView from "../components/BadgesView";
import { getBadgesExport } from "../repository/data.repository";
import { getProblemMessage } from "../utils/http";
import { useSelector } from "../store/store";
import { authorizeSelectors } from "../store/authorize";

function BadgesPage() {
  const permissions = useSelector(authorizeSelectors.permissions);
  const [modal, contextHolder] = Modal.useModal();
  const [searchQuery, setSearchQuery] = useState<SearchQuery>({
    conditions: [],
  });

  function onSearch(searchQuery: SearchQuery): void {
    setSearchQuery(searchQuery);
  }

  function onDownloadExport(): void {
    const loading = modal.info({
      content: (
        <Typography.Text className="m-1 ml-2 inline-block">
          Downloading badges export file..
        </Typography.Text>
      ),
      footer: null,
      centered: true,
      icon: <Loader />,
    });
    getBadgesExport({
      searchQuery,
      pageNumber: 0,
      pageSize: Number.MAX_SAFE_INTEGER,
    })
      .then(() => {
        loading.destroy();
      })
      .catch((err) => {
        loading.destroy();
        message.error(getProblemMessage(err) || "Failed to download export.");
      });
  }

  return (
    <Col className="relative flex flex-auto flex-col overflow-hidden overflow-y-auto">
      <Row className="sticky top-0 z-10 flex flex-row flex-wrap items-center p-4">
        <Typography.Title className="m-0 flex-auto" level={4}>
          Badges
        </Typography.Title>
        <Space className="flex flex-row">
          <Button
            type="primary"
            disabled={!permissions.can("Badges", "view")}
            onClick={onDownloadExport}
          >
            Export to Excel
          </Button>
        </Space>
      </Row>
      <Col className="flex flex-auto flex-col overflow-hidden p-4 pb-4 pt-0">
        <BadgesView onSearch={onSearch} />
      </Col>
      {contextHolder}
    </Col>
  );
}

export default BadgesPage;
